export default __webpack_public_path__ + "static/media/contact.8a576e54.jpg";